module.exports = __webpack_public_path__ + "static/img/videoCover.e21232e4.png";